import React from 'react';
import './../../style/Footer.css';

class Footer extends React.Component{
    render(){
        return (
            <div className="app-footer">
              <p>© NAPLAB 2018</p>
              <p>made in KOREA</p>
              <a href="#" className="go-top">TOP</a>
            </div>
        )
    }
}
     
export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js